/** @deprecated Used together with Popover, now its deprecated */
export default function () {
    const event = document.createEvent('MouseEvents');
    // @ts-ignore
    event.initMouseEvent('mousedown', true, true, window);
    document.body.dispatchEvent(event);
}
